import AlgorithmVisualizer from "./algorithm-visualiser"

export default function Rk() {
  return (
    <main style={{ background: '#0d1b2a', minHeight: '100vh', width: '100%' }}>
      <AlgorithmVisualizer />
    </main>
  )
}
